export enum objTypes {
  string = 'string',
  number = 'number',
  date = 'date',
  boolean = 'boolean',
  valueInPair = 'valueInPair',
  arrayPair = 'arrayPair',
  json = 'json',
  percentage = 'percentage',
  text = 'text',
  timeFrameData = 'timeFrameData',
  relatedUnit = 'relatedUnit',
  productRelatedKey = 'productRelatedKey',
  supplyChainListData = 'supplyChainListData',
  facilityFormPreview = 'facilityFormPreview',
  supplierData = 'supplierData',
  status = 'status',
  comment = 'comment'
}
